export const TYPE_TEMPLATES = {
  TARJETA_GESTION_EQUIPOS: 1,
  TARJETA_EQUIPOS_EN_TRANSACCION: 2,
  TARJETA_GESTION_PACTADOS: 3,
  FORMULARIO_GESTION_EQUIPOS: 4,
  REMITO_DATOS_CLIENTE: 5,
  REMITO_DATOS_EQUIPO: 6,
  TRADUCCION_CAMPOS_EQUIPOS_A_GESTION: 7,
};
